import LeadCard from './LeadCard.component';

export default LeadCard;